export var AgencyAgentsReviewOrder;
(function (AgencyAgentsReviewOrder) {
    AgencyAgentsReviewOrder["Helpful"] = "helpful";
    AgencyAgentsReviewOrder["New"] = "new";
    AgencyAgentsReviewOrder["Positive"] = "positive";
    AgencyAgentsReviewOrder["Negative"] = "negative";
})(AgencyAgentsReviewOrder || (AgencyAgentsReviewOrder = {}));
